/* Help Scout Beacon 2.0 - https://developer.helpscout.com/beacon-2/web/javascript-api/

We no longer need options here, all managed through GUI in version
2.0 (unless of course we want to force any options):
https://developer.helpscout.com/beacon-2/web/javascript-api/#beaconconfig-formobject
*/

!function(e,t,n){function a(){const e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){return false;});
window.Beacon('init', 'ced77731-709d-484c-85bf-5aa0833dcc0b');
